const getters = {
  devices: (state) => state.list,
  simpleDevices: (state) => state.simpleList,
  thirdPartyDevices: (state) => state.thirdPartyDevices,
};

export default getters;
